<template>
  <div class="col-md-4 ml-auto mr-auto">
    <form @submit.prevent="login">
      <card class="card-login card-plain">
        <div slot="header">
          <div class="logo-container">
            <img :src="logoSrc" alt />
          </div>
        </div>

        <div>
          <div class="text-center login-title">
            <h3>
              <router-link class="link footer-link" to="/register">登入跳轉中</router-link>
            </h3>
          </div>
        </div>

        <div slot="footer"></div>
      </card>
    </form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "login",
  data() {
    return {
      model: {
        email: "",
        password: ""
      }
    };
  },
  computed: {
    logoSrc() {
      // "img/qc_logo.png"
      return process.env.VUE_APP_LOGO;
    }
  },
  mounted() {
    this.login();
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async login() {
      // 抓出redirect的資料
      // get user profile
      // return axios
      //   .get(`${process.env.VUE_APP_APIHOST}/apis/me`)
      //   .then(response => {
      //     this.data = response.data;

      //     return response.data;
      //   });
      this.$store
        .dispatch("authenticate")
        .then(() => {
          // 接收 resolve
          // console.log('3. get Promise resolve');
          setTimeout(() => {
            // 使用 $router.push 轉跳到 hello Page
            this.$router.push("/");
          }, 1000);
        })
        .catch(e => {
          // 接收 reject
          console.log("error get Promise reject!" + e.stack);
        });
      // let isValidForm = await this.$validator.validateAll();
      // if (isValidForm) {
      //   // TIP use this.model to send it to api and perform login call

      //   // 因為 action 包裝了 Promise 所以可以使用 then 和 catch 來接收非同步回傳狀態
      //   this.$store
      //     .dispatch("login", {
      //       type: "eaa",
      //       username: this.model.email,
      //       password: this.model.password
      //     })
      //     .then(() => {
      //       // 接收 resolve
      //       // console.log('3. get Promise resolve');
      //       setTimeout(() => {
      //         // 使用 $router.push 轉跳到 hello Page
      //         this.$router.push("/");
      //       }, 1000);
      //     })
      //     .catch(e => {
      //       // 接收 reject
      //       console.log("error get Promise reject!" + e.stack);
      //     });
      // }
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
